exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._cNRtwoABiEV7jcRJa4g3 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n}\n", ""]);

// exports
exports.locals = {
	"loading": "_cNRtwoABiEV7jcRJa4g3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./src/components/Loading/index.module.css
// module id = 22
// module chunks = 0 1 7